import CryptoJS from "crypto-js";

const base64_encode = (str) => CryptoJS.enc.Base64.stringify(str).replace(/=+$/, '').replace(/\+/g, '-').replace(/\//g, '_');

export const jwt = (data, secret) => {
	const token = base64_encode(CryptoJS.enc.Utf8.parse(JSON.stringify({"alg": "HS256", "typ": "JWT"})))
		+ "."
		+  base64_encode(CryptoJS.enc.Utf8.parse(JSON.stringify(data)));
	return token + "." + base64_encode(CryptoJS.HmacSHA256(token, secret))
}